//import { css } from "@emotion/react"

import { useEffect } from "react";
import { useTranslate } from "@/hooks/useTranslate/useTranslate";
import { ShoppingCartControl } from "../components/ShoppingCart/ShoppingCartControl";
import { SiteLayout } from "../components/SiteLayout";
import { useStorefrontSettingsState } from "../hooks/useStorefrontSettingsState";

//export type ShoppingCartPageProps = {};
export const ShoppingCartPage: React.FC /*<ShoppingCartPageProps>*/ = () => {
	const translate = useTranslate();
	// reload the storefront settings in case they changed
	const storefrontSettingsState = useStorefrontSettingsState();
	useEffect(() => {
		storefrontSettingsState.loadAsync();
	}, [storefrontSettingsState]);

	return (
		<div>
			<SiteLayout
				title={translate("Shopping Cart")}
				mainChildren={<ShoppingCartControl />}
			/>
		</div>
	);
};
